import { Box } from "../../box";
import { useButton } from "./useButton";
import { Children, forwardRef } from "react";
import { EmbeddedIcon } from "../../icons";
import { as, augmentElement, createEmbeddableAdapter, mergeProps, omitProps, slot } from "../../shared";
import { useResponsiveValue } from "../../styling";
import { useInputGroupButtonAddonProps } from "../../input-group";
import { useToolbarProps } from "../../toolbar";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "button";
export function InnerIconButton(props) {
  const [toolbarProps] = useToolbarProps();
  const [inputGroupProps] = useInputGroupButtonAddonProps();
  const {
    active,
    "aria-label": ariaLabel,
    as: asProp = DefaultElement,
    autoFocus,
    children,
    condensed,
    fluid,
    focus,
    forwardedRef,
    hover,
    inherit,
    loading,
    shape = "circular",
    size,
    type,
    variant = "secondary",
    ...rest
  } = mergeProps(props, omitProps(toolbarProps, ["orientation"]), inputGroupProps);
  const fluidValue = useResponsiveValue(fluid);
  const sizeValue = useResponsiveValue(size);
  const buttonProps = useButton({
    active,
    as: asProp,
    autoFocus,
    cssModule: "o-ui-icon-button",
    fluid: fluidValue,
    focus,
    forwardedRef,
    hover,
    inherit,
    loading,
    shape,
    size: sizeValue,
    type,
    variant
  });
  const icon = Children.only(children);
  const iconMarkup = augmentElement(condensed ? icon : /*#__PURE__*/_jsx(EmbeddedIcon, {
    children: icon
  }), {
    className: "o-ui-button-icon",
    size: sizeValue
  });
  return /*#__PURE__*/_jsx(Box, { ...mergeProps(rest, {
      "aria-label": ariaLabel,
      as: asProp
    }, buttonProps),
    children: iconMarkup
  });
}
InnerIconButton.defaultElement = DefaultElement;
export const IconButton = slot("button", /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerIconButton, { ...props,
  forwardedRef: ref
})));

/* eslint-disable sort-keys, sort-keys-fix/sort-keys-fix */
export const embedIconButton = createEmbeddableAdapter({
  "sm": "2xs",
  "md": "xs"
});
/* eslint-enable sort-keys, sort-keys-fix/sort-keys-fix */
///////////

export const IconButtonAsLink = as(IconButton, "a");